export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_URL_WITHOUT_API = process.env.REACT_APP_URL;
export const SOCKET_URL = process.env.REACT_APP_API_SOCKET_URL;
export const FINGER_SOCKET_URL = process.env.REACT_APP_API_SOCKET_URL_FINGER;
export const DATE = '2027-07-30';
